import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { browserConfig } from './app/app.config.browser';
import { AppConfig } from '@boels/models';

fetch(environment.configPath)
  .then((response) => response.json())
  .then((config: AppConfig) => {
    if (environment.production) {
      enableProdMode();
    }
    return bootstrapApplication(AppComponent, {
      providers: [
        {
          provide: 'ENVIRONMENT',
          useValue: config,
        },
        ...browserConfig.providers,
      ],
    }).catch((err) => console.error(err));
  });
